<h2 mat-dialog-title>Confirm PARCS Sync</h2>
<mat-dialog-content>
<span class="component-font-title">spACE AR Parker Data</span>
<form [formGroup]="parkerDataForSync" style="margin-top:10px;">
<div class="row">
    <div class="col-3">
         <mat-form-field style="width:98%;" appearance="outline" >
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="parkerCompanyName" 
                required readonly="true" >
        </mat-form-field>
    </div>
    <div class="col-3">
        <mat-form-field style="width:98%;">
            <mat-label>First Name</mat-label>
            <input matInput formControlName="parkerFirstName" 
                required>
            <mat-error>The First Name is rquired</mat-error>
        </mat-form-field>
    </div>
    <div class="col-3">
         <mat-form-field style="width:98%;">
            <mat-label>Last Name</mat-label>
            <input matInput formControlName="parkerLastName" 
                required>
            <mat-error>The Last Name is required</mat-error>
        </mat-form-field>
    </div>
     <div class="col-3">
         <mat-form-field style="width:98%;" >
            <mat-label>Card Number</mat-label>
            <input matInput formControlName="parkerCardNumber" 
                type="text"
                pattern="[0-9]*"
                inputmode="numeric"
                (input)="onCardNumberChange($event)"
                (keypress)="onKeyPress($event)"
                (paste)="onPaste($event)"
                required>
            @if(cardNumberCheckInProgress) {
                <mat-hint>Checking card number...</mat-hint>
            }
            @if(parkerDataForSync.get('parkerCardNumber')?.hasError('cardNumberExists')) {
                <mat-error>This card number already exists</mat-error>
            }
            @if(!cardNumberExists && !cardNumberCheckInProgress && parkerDataForSync.get('parkerCardNumber')?.value) {
                <mat-hint style="color: green;">Card number is available</mat-hint>
            }
        </mat-form-field>
    </div>
</div>
</form>
    @if(isNewAccessHolder) {
        <div class="col-4">
            <mat-form-field appearance="fill" class="gray-text" style="width:96%">    
                <mat-label>Select Amano One PARCS Access Group*</mat-label>
                <mat-select [ngModel]="accessGroupId" (ngModelChange)="onAccessGroupChange($event)">
                    @if(amanoOneAccessGroups.length === 0) {
                        <mat-option value="">Loading Access Groups...</mat-option>
                    }
                    @else {
                        <mat-option value="">Select Access Group</mat-option>
                        <mat-option *ngFor="let group of amanoOneAccessGroups" [value]="group.accessGroupID" >
                        {{group.name}}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <br /><span style="font-weight:normal;font-size:14px;position:relative;top:-15px;left:10px;">By default Parker status = neutral, mode=normal</span>   
        </div>
    }

<div class="row">
    <div class="col-11">
        <span>Clicking "Sync Now" will save any changes to the first and last name to the spACE AR Parker profile, and then sync the parker data to Amano One.</span><br /><br />
        <span>Note that during this sync process, the following spACE AR Parker data will update any existing matching PARCS profiles with the following Parker data.</span>
        <ul>
            <li>Last Name</li>
            <li>First Name</li>
            <li>Company Name</li>
            <li>Card Number</li>
            <li>Vehicle(s) Information</li>
            <li>Email Address</li>
            <li>Start Date</li>
            <li>End Date</li>
            
        </ul>
    </div>
</div>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button cdkFocusInitial [disabled]="!parkerDataForSync.valid || !isAccountIdReady" (click)="onSyncNow()">Sync Now</button>
</mat-dialog-actions>




                    